import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

const PrivacyPolicy: React.FC = () => {
  const { translations } = useLanguage();

  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Typography variant="h3" gutterBottom sx={{ fontWeight: "bold" }}>
          {translations.privacy_policy_text.title}
        </Typography>
        <Typography variant="subtitle1" sx={{ color: "text.secondary" }}>
          {translations.privacy_policy_text.intro}
        </Typography>
      </Box>

      {translations.privacy_policy_text.sections.map((section, index) => (
        <Box key={index} sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold" }}>
            {section.title}
          </Typography>
          <Typography variant="body1" sx={{ whiteSpace: "pre-line" }}>
            {section.content}
          </Typography>
        </Box>
      ))}
    </Container>
  );
};

export default PrivacyPolicy;
